import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import Config from '../config/Config';
import { encodeBase64Url } from '../components/Utils';
import { FormControl, Button, Alert, InputGroup } from 'react-bootstrap';
import { IoSearchSharp } from "react-icons/io5";
import SectionWrapper from '../components/SectionWrapper';
import '../css/SearchPage.css';

const SearchPage = () => {
    const { mainColor } = Config.appearance;

    const [query, setQuery] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const intl = useIntl();

    const sectionTitle = intl.formatMessage({ id: 'search_product' });
    const placeholder = intl.formatMessage({ id: "please_enter_serial_number" });
    const errorPleaseEnterValidSerialNumber = intl.formatMessage({ id: "error_please_enter_valid_serial_number" });

    const searchMaxLength = 30;

    const handleSearch = () => {
        if (query.trim() === '') {
            setError(errorPleaseEnterValidSerialNumber);
            return;
        }
        navigate(`/search?query=${encodeBase64Url(query)}`);
    };

    const handleChange = (e) => {
        setQuery(e.target.value);
        if (error) setError('');
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') handleSearch();
    };

    return (
        <div className="search-container d-flex justify-content-between align-items-top my-5">
            <SectionWrapper
                title={sectionTitle}
                titleStyle={{ '--dpp-main-color': mainColor }}
                contentStyle={{ padding: '15px' }}
            >
                {error && (
                    <Alert variant="warning" dismissible onClose={() => setError('')}>
                        {error}
                    </Alert>
                )}

                <InputGroup className="search-input-group" style={{ '--dpp-main-color': mainColor }}>
                    <FormControl
                        className="search-input"
                        type="search"
                        enterKeyHint="search"
                        placeholder={placeholder}
                        value={query}
                        maxLength={searchMaxLength}
                        onChange={handleChange}
                        onKeyDown={handleKeyPress}
                    />
                    <Button
                        variant="primary"
                        onClick={handleSearch}
                        className="search-button"
                    >
                        <IoSearchSharp className="search-icon" />
                    </Button>
                </InputGroup>
            </SectionWrapper>
        </div>
    );
};

export default SearchPage;